module.exports = __webpack_public_path__ + "media/images/responsive/flow/flow3-dress-8742217afd22cdb854215989faf1204f.jpg";